import { combineReducers } from 'redux';
import my from './my'
import me from './me'

export default combineReducers({
	my: my,
	me: me,

})
